const data = {
    title: '4. Effectanalyse zoekgebieden zon en wind',
    content: <>
        <p>Er is in deze fase van de MER nog geen concreet en eenduidig beeld van de plannen of projecten in de zoekgebieden. Om dit te ondervangen wordt daarom niet een plan of project beoordeeld, maar alleen de kans op een acceptabele inpassing van toekomstige ontwikkeling van windenergie en zonne-energie binnen de zoekgebieden aan de hand van de mogelijke milieueffecten. De milieueffecten zijn daarmee slechts een globale inschatting van de mogelijke ruimtelijke gevolgen. Iedere paragraaf presenteert per criterium de effectanalyse op het niveau van de zoekgebieden. Per criterium is de referentiesituatie beschreven (en op kaart gezet) en is de beoordelingsmethodiek toegelicht. De analyses resulteren per aspect in een effectbeoordeling in de vorm van kaarten die aangeven in hoeverre de zoekgebieden vanuit milieuperspectief:</p>
        <ul>
            <li>Redelijk kansrijk tot kansrijk zijn (lichtpaarse contouren)</li>
            <li>Matig kansrijk tot kansrijk te maken zijn (middenpaarse contouren) </li>
            <li>Niet tot nauwelijks kansrijk zijn (donkerpaarse contouren).</li>
        </ul>
    </>,
    prev: '/energietransitie/3/3',
    next: '/energietransitie/4/1',

}

export default data

